import React from 'react';
import { Card } from '../components/ui/card';

function ReturnsPolicyPage() {
  return (
    <div className="min-h-screen py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl font-display font-normal mb-8">Returns & Refunds Policy</h1>
        
        <Card className="p-6 space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">7 Working Days Return Policy</h2>
            <p className="text-muted-foreground">
              We want you and your kids to love our products! If you're not completely satisfied, 
              you can return unused or damaged products within <strong>7 working days</strong> of delivery.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Eligibility for Returns</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Product must be unused and in original condition, OR received damaged</li>
              <li>Original packaging and tags must be intact (for unused returns)</li>
              <li>Return request must be initiated within 7 working days of delivery</li>
              <li>For damaged products, please share photos of the damage</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Non-Returnable Items</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Products that have been used or washed</li>
              <li>Items with removed or damaged tags</li>
              <li>Products purchased during special sales (if specified)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">How to Initiate a Return</h2>
            <ol className="list-decimal list-inside space-y-2 text-muted-foreground">
              <li>Go to "My Orders" and select the order you want to return</li>
              <li>Click "Request Return" and select the reason</li>
              <li>Our team will review and approve your request within 24 hours</li>
              <li>Pack the product securely in original packaging</li>
              <li>Our courier partner will pick up the product from your address</li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Refund Process</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Refunds are processed within 5-7 business days after we receive the returned product</li>
              <li><strong>Refund will be credited to the original payment method used during purchase</strong></li>
              <li>You'll receive an email/WhatsApp notification once the refund is processed</li>
              <li>Bank processing may take additional 3-5 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Exchanges</h2>
            <p className="text-muted-foreground">
              We currently don't offer direct exchanges. Please return the product for a refund 
              and place a new order for the item you'd like.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Damaged or Defective Products</h2>
            <p className="text-muted-foreground">
              If you receive a damaged or defective product, please contact us immediately with photos. 
              We'll arrange a free return pickup and issue a full refund or send a replacement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <p className="text-muted-foreground">
              For return queries, contact us:
            </p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li><strong>F Square Media</strong></li>
              <li>Address: Panchsheel Park, New Delhi - 110017</li>
              <li>Email: motheringin@gmail.com</li>
              <li>Phone/WhatsApp: +91 88103 45965</li>
            </ul>
          </section>
        </Card>
      </div>
    </div>
  );
}

export default ReturnsPolicyPage;